<template>
  <div class="content" v-for="ctem in videoData[0]?.content" :key="ctem.index">
    <h2>{{ ctem.conName }}</h2>
    <div class="con-one" v-for="vtem in ctem.contents" :key="vtem.index">
      <div class="one" @click="changeShow(vtem)">
        <i class="blue"></i>
        <h4>{{ vtem.contName }}</h4>
        <i
          v-if="vtem.isShow"
          style="font-size: 25px; color: #0a7fec"
          class="iconfont icon-xiajiantou"
        ></i>
        <i v-else style="font-size: 25px" class="iconfont icon-youjiantou"></i>
      </div>
      <Transition name="slide-fade">
        <div class="tree" v-show="vtem.isShow">
          <div class="con-three">
            <ul v-for="ltem in vtem.units" :key="ltem.index">
              <a target="_blank" @click="hitContent(ltem)">
                <li class="con-left" :title="ltem.vName">
                  <span>{{ ltem.vName }}</span>
                </li>
                <li class="con-right">
                  <span>{{ ltem.vTime }}</span>
                  <el-icon color="#909399" size="16"><Lock /></el-icon>
                </li>
              </a>
            </ul>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import { ElMessageBox } from "element-plus";
export default {
  props: {
    videoData: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const changeShow = (vtem) => {
      try {
        vtem.isShow = !vtem.isShow;
      } catch (error) {
        console.log(error);
      }
    };
    const hitContent = () => {
      try {
        ElMessageBox.alert(
          "<p>请购买之后联系官网老师开通专属听课账号听课</p><p>刘老师(微信):18019934025</p><p>徐老师(微信):13205515869</p><p>黄老师(微信):13075567156</p><p>刘校长(微信):18505513002</p>",
          "欢迎来到山河医学网",
          {
            dangerouslyUseHTMLString: true,
          }
        );
      } catch (error) {
        console.log(error);
      }
    };
    return { changeShow, hitContent };
  },
};
</script>

<style lang="less" scoped>
.content {
  h2 {
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .con-one {
    width: 100%;
    //height: 50px;
    cursor: pointer;
    .one {
      display: flex;
      height: 50px;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;
      /* align-items: center; */

      .blue {
        display: inline-block;
        width: 3px;
        height: 20px;
        background: @shColor;
      }
      h4 {
        margin-left: 15px;
      }
    }
    .con-three {
      //height: 30px;
      ul {
        a {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 50px;
          //background: #f4f4f5;
          border-bottom: 1px solid #f5f5f5;
          border-right: 1px solid #f5f5f5;
          border-left: 1px solid #f5f5f5;
          &:hover {
            //background: #f5f5f5;
            color: @shColor;
          }

          .con-left {
            display: flex;
            align-items: center;
            margin-left: 45px;
            margin-right: 18px;
            font-size: 16px;

            span {
              display: inline-block;
              width: 680px;
              line-height: 30px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .con-right {
            display: flex;
            align-items: center;
            margin-right: 20px;
            span {
              margin-right: 15px;
            }
          }
        }
      }
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.3, 0.5, 0.3, 0.5);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
